<template lang="pug">
  div(class="container")
    div(v-if="slider").pb-0
      v-row().px-4
          v-flex(xs8 md10 lg10).pr-2
            v-slider(label="Number of Incidents:" v-model="top" :min="min" :max="max" thumb-label="always" :thumb-size="32" @click="buildData")
          v-flex(xs4 md2 lg2)
            v-slider(v-model="gradientSwitch" label="Gradient" :min="0" :max="1" step="1" ticks="always" tick-size="6" @click="buildData")
    heat-map(v-if="loaded" :points="points" width="100%" :height="height" :lat="38.878337" :lng="-77.100703" :initial-zoom="zoom" :map-type="maptype" :componentkey="componentkey" :gradient="gradient" )
    div(class="text-center" v-if="!loaded").mt-12
      v-progress-circular(indeterminate class="mb-2" :size="50" :width="5" color="primary")
    
</template>
 
<script>
import HeatMap from "../HeatMap.vue";
export default {
  name: "PoliceIncidentHeatMap",
  components: { HeatMap },
  props: {
    width: Number,
    height: Number,
    limit: Number,
    maptype: String,
    zoom: Number,
    slider: Boolean
  },
  data() {
    return {
      loaded: false,
      points: [],
      min: 100,
      max: 5000,
      top: Number,
      componentkey: 0,
      gradientSwitch: false
    };
  },
  mounted() {
    this.loaded = false;
    this.top = this.limit;
    this.buildData();
  },
  computed: {
    gradient() {
      return this.gradientSwitch
        ? [
            "rgba(0, 255, 255, 0)",
            "rgba(0, 255, 255, 1)",
            "rgba(0, 191, 255, 1)",
            "rgba(0, 127, 255, 1)",
            "rgba(0, 63, 255, 1)",
            "rgba(0, 0, 255, 1)",
            "rgba(0, 0, 223, 1)",
            "rgba(0, 0, 191, 1)",
            "rgba(0, 0, 159, 1)",
            "rgba(0, 0, 127, 1)",
            "rgba(63, 0, 91, 1)",
            "rgba(127, 0, 63, 1)",
            "rgba(191, 0, 31, 1)",
            "rgba(255, 0, 0, 1)"
          ]
        : null;
    }
  },
  methods: {
    buildData() {
      this.getData()
        .then(this.groupData)
        .then(this.plotData);
    },

    getData() {
      return new Promise(resolve => {
        fetch(
          `https://datahub-v2.arlingtonva.us/api/Police/IncidentLog?$top=${this.top}&$orderby=firstReportDtm desc`
        ).then(response => {
          resolve(response.json());
        });
      });
    },
    groupData(data) {
      return data.map(d => {
        return { lat: d.latitudeCrd, lng: d.longitudeCrd };
      });
    },
    plotData(data) {
      this.points = data;
      this.loaded = true;
      this.componentkey += 1;
    }
  }
};
</script>